export default __webpack_public_path__ + "static/media/Lori_Dron_Short1.5b434614.mp4";